import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AppStoreSearch } from "./AppStoreSearch";
import { ABMAppsSelect } from "./ABMAppsSelect";
import { PrivateAppUpload } from "./PrivateAppUpload";
import { AppStoreSearchResult, ABMApp } from "@/types/application";
import { PkgUploadResult } from "@/types/api";
import { Store, Building2, Package } from "lucide-react";

export type SelectedApp =
  | { type: 'appStore'; app: AppStoreSearchResult }
  | { type: 'abm'; app: ABMApp }
  | { type: 'private'; app: PkgUploadResult['application'] };

interface ApplicationCatalogProps {
  onSelectApp: (selection: SelectedApp) => void;
  selectedAppId?: string;
  initialSearchTerm?: string;
}

export const ApplicationCatalog = ({ onSelectApp, selectedAppId, initialSearchTerm }: ApplicationCatalogProps) => {
  const [activeTab, setActiveTab] = useState("appStore");

  const handleAppStoreSelect = (app: AppStoreSearchResult) => {
    onSelectApp({ type: 'appStore', app });
  };

  const handleABMSelect = (app: ABMApp) => {
    onSelectApp({ type: 'abm', app });
  };

  const handlePrivateUploaded = (app: PkgUploadResult['application']) => {
    onSelectApp({ type: 'private', app });
  };

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="appStore" className="flex items-center gap-2">
          <Store className="h-4 w-4" />
          App Store
        </TabsTrigger>
        <TabsTrigger value="abm" className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Apps & Books (ABM)
        </TabsTrigger>
        <TabsTrigger value="private" className="flex items-center gap-2">
          <Package className="h-4 w-4" />
          Private (.pkg)
        </TabsTrigger>
      </TabsList>
      <TabsContent value="appStore" className="mt-4">
        <AppStoreSearch onSelectApp={handleAppStoreSelect} selectedAppId={selectedAppId} initialSearchTerm={initialSearchTerm} />
      </TabsContent>
      <TabsContent value="abm" className="mt-4">
        <ABMAppsSelect onSelectApp={handleABMSelect} selectedAppId={selectedAppId} />
      </TabsContent>
      <TabsContent value="private" className="mt-4">
        <PrivateAppUpload onUploaded={handlePrivateUploaded} />
      </TabsContent>
    </Tabs>
  );
};
